import { render, staticRenderFns } from "./studioEditor.vue?vue&type=template&id=33978be4&scoped=true"
import script from "./studioEditor.vue?vue&type=script&lang=js"
export * from "./studioEditor.vue?vue&type=script&lang=js"
import style0 from "./studioEditor.vue?vue&type=style&index=0&id=33978be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33978be4",
  null
  
)

export default component.exports